<template>
  <div class="form-base">
    <ItemHeader
      title="Кредитор"
      :expand="v.expand.$model"
      :btn-delete-visible="canDelete"
      btn-delete-text="Удалить кредитора"
      @btn-expand-click="v.expand.$model = !v.expand.$model"
      @btn-delete-click="$emit('delete')"
    />

    <v-expand-transition>
      <div v-show="v.expand.$model">
        <div class="form-section-base__controls" v-if="isMrpaEnable">
          <v-row>
            <v-col>
              <v-radio-group v-model="v.fillType.$model" row>
                <v-radio label="Кредитор" :value="SubjectFillType.MANUAL" />
                <v-radio
                  label="Представитель по доверенности в машиночитаемом виде"
                  :value="SubjectFillType.MACHINE"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </div>

        <Manual
          v-if="v.fillType.$model === SubjectFillType.MANUAL"
          :v="v.manual"
        />

        <Machine
          v-if="v.fillType.$model === SubjectFillType.MACHINE"
          :v="v.machine"
          @parsed-mrpa-change="$emit(AppEvent.PARSED_MRPA_CHANGE, $event)"
        />

        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              Реквизиты кредитора для получения безналичных денежных средств
            </div>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="v.account.recipientName.$model"
              :errorMessages="getValidationErrorText(v.account.recipientName)"
              outlined
              label="Наименование получателя"
            />
          </v-col>
          <v-col cols="6">
            <CurrencyField
              v-model="v.account.amount.$model"
              label="Размер денежных средств"
              :errorMessages="getValidationErrorText(v.account.amount)"
            />
          </v-col>
        </v-row>

        <BankDetails :v="v.account" />

        <v-row>
          <v-col cols="12">
            <div class="form-base__title">Остальные сведения по кредитору</div>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="v.details.information.$model"
              :errorMessages="getValidationErrorText(v.details.information)"
              label="Иные сведения о кредиторе"
              outlined
            />
          </v-col>

          <v-col cols="6">
            <DateFieldCustom
              label="Срок передачи кредитору безналичных денежных средств"
              :value="v.details.transferTimeLimit.$model"
              :errorMessage="v.details.transferTimeLimit"
              @change="v.details.transferTimeLimit.$model = $event"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="v.details.transferCondition.$model"
              :errorMessages="
                getValidationErrorText(v.details.transferCondition)
              "
              label="Условия передачи кредитору безналичных денежных средств"
              outlined
            />
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import ItemHeader from '@/components/services/elements/ItemHeader';
import Manual, { manualModel, getManualValidation } from './Manual';
import Machine, { machineModel, getMachineValidation } from './Machine';
import { StatementType, SubjectFillType } from '@/constants';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import deepmerge from 'deepmerge';
import { and, maxLength, required } from 'vuelidate/lib/validators';
import {
  CURRENCY_MAX_LENGTH,
  CURRENCY_ONLY_POSITIVE,
  DATE_FORMAT,
  DATE_PAST,
  EMOJI,
} from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import CurrencyField from '@/components/base/CurrencyField';
import { isMrpaEnable } from '@/app.config';
import { getValidationErrorText } from '@/utils/validate';
import { AppEvent } from '@/constants';

export const creditorModel = {
  expand: true,
  fillType: SubjectFillType.MANUAL,
  manual: manualModel,
  machine: machineModel,
  account: {
    recipientName: '',
    amount: null,
    currency: 'RUB',
    ...bankDetails,
  },
  details: {
    information: '',
    transferTimeLimit: '',
    transferCondition: '',
  },
};

const getCreditorBaseValidation = () => ({
  expand: {},
  fillType: {},
  account: deepmerge(bankDetailsValidation, {
    recipientName: {
      required,
      maxLength: maxLength(255),
      EMOJI,
    },
    amount: {
      required,
      CURRENCY_MAX_LENGTH,
      CURRENCY_ONLY_POSITIVE,
    },
  }),
  details: {
    information: {
      maxLength: maxLength(4000),
      EMOJI,
    },
    transferTimeLimit: {
      required,
      DATE: and(DATE_FORMAT, DATE_PAST),
    },
    transferCondition: {
      required,
      maxLength: maxLength(1000),
      EMOJI,
    },
  },
});

export const getCreditorValidation = (creditor) => {
  if (creditor.fillType === SubjectFillType.MANUAL) {
    return {
      ...getCreditorBaseValidation(),
      manual: getManualValidation(creditor.manual),
    };
  }

  return {
    ...getCreditorBaseValidation(),
    machine: getMachineValidation(creditor.machine),
  };
};

export default {
  name: 'Creditor',
  components: {
    ItemHeader,
    Machine,
    Manual,
    DateFieldCustom,
    CurrencyField,
    BankDetails,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isMrpaEnable() {
      return isMrpaEnable(StatementType.ACCEPTANCE_ESCROW);
    },
  },
  data: () => ({
    AppEvent,
    SubjectFillType,
    getValidationErrorText,
  }),
};
</script>
